import './style.scss';
import 'bootstrap/js/dist/collapse';
import $ from 'jquery';
import React, { useRef, useState, useEffect } from 'react';

import ReactDOM from 'react-dom';

import './highlight';

document.addEventListener('DOMContentLoaded', () => {
	const divsToUpdate = document.querySelectorAll(
		'.ae-block-accordion .filter-search-bar'
	);

	divsToUpdate.forEach(function (div) {
		const dataEl = div.querySelector('pre');
		const data = JSON.parse(dataEl.innerHTML);

		ReactDOM.render(<SearchBar {...data} />, div);
	});
});

function SearchBar(props) {
	const initialPageLoad = useRef(0);
	const [originalText, setOriginalText] = useState({});
	const inputTextRef = useRef(null);

	function searchAccordion() {
		// Declare variables
		const accordionInputs = $('.ae-block-accordion .search-bar input');
		accordionInputs.each(function () {
			let text, txtValue;
			const input = this;
			const filter = input.value.toUpperCase();
			const accordion = $(this).parent().parent().parent();
			const accGrpBody = $(accordion).find('.accordion-body');
			// Loop through all list items, and hide those who don't match the search query
			accGrpBody.each(function () {
				text = this;
				txtValue = $(text).text();

				const headingEl = $(this)
					.parent()
					.parent()
					.parent()
					.find('.accordion-header');
				const headingElText = $(headingEl).text();

				if (
					txtValue.toUpperCase().indexOf(filter) > -1 ||
					headingElText.toUpperCase().indexOf(filter) > -1
				) {
					$(text).parent().parent().parent().slideDown();
				} else {
					$(text).parent().parent().parent().slideUp();
				}
			});
		});
	}

	useEffect(() => {
		if (initialPageLoad.current === 0) {
			const accordion = $(inputTextRef.current)
				.parent()
				.parent()
				.parent();
			const accGrpBodies = $(accordion).find('.accordion-body');
			// Loop through all list items, and hide those who don't match the search query
			let originalTextDict = {};
			accGrpBodies.each(function (index) {
				const accGrpBody = this;
				originalTextDict = {
					...originalTextDict,
					[index]: accGrpBody.innerHTML,
				};
			});
			setOriginalText(originalTextDict);
			initialPageLoad.current = initialPageLoad.current + 1;
		}
	}, []);

	function hightlightText(val) {
		const accordion = $(inputTextRef.current).parent().parent().parent();
		// Declare variables

		const accGrpBodies = $(accordion).find('.accordion-body');
		// Loop through all list items, and hide those who don't match the search query
		accGrpBodies.each(function (index) {
			// Loop through all list items, and hide those who don't match the search query
			$(this).html(originalText[index]);
			$(this).highlight(val.target.value);
		});
	}

	return (
		<div className="search-bar form-inline">
			<input
				className="form-control"
				onKeyUp={searchAccordion}
				onChange={hightlightText}
				ref={inputTextRef}
				type="text"
				placeholder={props.searchPlaceholder}
			/>
		</div>
	);
}
